<template>
  <div class="outline">
    <header class="light outline">
      <h5 class="comfortaa">Subscriptions</h5>
      <p>0 Renewing Subscriptions</p>
    </header>
    <div class="w3-row w3-white">
      <template v-if="state.user.subs.list.length > 0">
        <table class="w3-table w3-bordered paymentMethodResults" :class="state.width > 1024 ? '' : 'w3-responsive'">
          <tr class="w3-light-grey">
            <td style="min-width:250px;">Items</td>
            <td class="w3-center" style="width:90px;">Started</td>
            <td class="w3-center" style="width:90px;">Renews</td>
            <td class="w3-center" style="width:90px;">Total</td>
            <td class="w3-center" style="width:90px;">Status</td>
            <td class="w3-center" style="width:100px;">Actions</td>
          </tr>
          <tr v-for="(sub, index) in state.user.subs.list" :key="index" class="subRow">
            <td @click="viewSubDetails(sub)">
              <span v-for="(item, key, i) in sub.items.data" :key="i">
                {{item.plan.nickname}}<span v-if="key < Object.keys(sub.items.data).length - 1">, </span>
              </span>
            </td>
            <td class="w3-center">{{sub.current_period_start | date}}</td>
            <td class="w3-center" v-if="!sub.cancel_at_period_end">{{sub.current_period_end | date}}</td>
            <td class="w3-center w3-text-orange" v-else>Cancelling</td>
            <td class="w3-center">{{sub.total / 100 | currency}}</td>
            <td class="w3-center" :class="{'w3-text-green': (sub.status === 'paid'),'w3-text-red': (sub.status === 'overdue'),'w3-text-orange': (sub.status === 'open'),'w3-text-light-grey': (sub.status === 'draft')}">{{sub.status | capitalize}}</td>
            <td class="w3-center">
              <button @click.prevent="cancelSub(sub)" class="w3-button w3-red w3-small">cancel</button>
            </td>
          </tr>
        </table>
      </template>
      <template v-else>
        <div class="w3-container">
          <p style="margin-top:15px;">No Subscriptions Yet</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
var dataStore = require("../dataStore").default;

export default {
  name: 'subscriptionList',
  data () {
    return {
      state: dataStore.state
    }
  },
  methods: {
    cancelSub(sub) {
      let product = this.state.productData.products.data.find(product => product.id === sub.plan.product)
      if (window.confirm('WARNING: THIS WILL CANCEL YOUR SUBSCRIPTION & ANY RELATED SERVICES! Are you sure you want to cancel your subscription to ' + product.name + ' - ' + sub.plan.nickname + '?')) {
        const subData = {subid: sub.id}
        dataStore.cancelSubscription(subData, false).then((res) => {
          dataStore.getCustomerSubs()
        })
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/subscriptionList.vue